import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Transition from 'Components/ComponentLibrary/Atoms/Transition';

const getStatus = ({
  errors, isSaving, lastSaved,
}) => {
  if (isSaving) {
    return { color: 'primaryGray', message: 'Saving...' };
  }

  if (errors.length > 0) {
    const [error] = errors;
    return { color: 'error', message: error.detail };
  }

  if (lastSaved) {
    return {
      color: 'primaryGray',
      message: `Last saved ${moment(lastSaved).calendar()}`,
    };
  }

  return {
    color: 'primaryGray',
    message: '',
  };
};

const AutosaveStatusMessage = ({
  errors,
  isDirty,
  isSaving,
  lastSaved,
  test,
}) => {
  const { color, message } = getStatus({
    errors,
    isDirty,
    isSaving,
    lastSaved,
  });

  return (
    <Transition key={message} timeout={1000}>
      <span>
        <Text
          align="left"
          color={color}
          noWrap
          test={test}
          text={message}
          title={message}
          variant="fineprint"
        />
      </span>
    </Transition>
  );
};

AutosaveStatusMessage.defaultProps = {
  errors: [],
  isDirty: false,
  isSaving: false,
  lastSaved: undefined,
  test: undefined,
};

AutosaveStatusMessage.propTypes = {
  errors: PropTypes.array,
  isDirty: PropTypes.bool,
  isSaving: PropTypes.bool,
  lastSaved: PropTypes.string,
  test: PropTypes.string,
};

export default AutosaveStatusMessage;
